import { Component, OnInit } from '@angular/core';
import { DataService } from '../../../services/data/data.service';
import { TranslateService } from '@ngx-translate/core';
import { AltaplanificacionesService } from '../../../services/administrador-gestion/alta-planes/altaplanificaciones.service';
import { Instituciones, obtenerError, Planificacion, Responsables, Semaforos } from '../../../models/Formulacion/indicadores-metas/datos';
import { ExcelService } from '../../../services/excel/excel.service';
import Swal from 'sweetalert2';
import { messages } from '../../funciones/mensajes';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ContenedorService } from '../../../services/contenedor/contenedor.service';
import { firstValueFrom } from 'rxjs';
import moment from 'moment';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { ArraysOrder } from '../../funciones/funcionesGenerales';
import { PlanificacionService } from '../../../services/gestion/planificacion/planificacion.service';
import { ResponsableService } from '../../../services/gestion/responsable/responsable.service';
import { SemaforoService } from '../../../services/gestion/semaforo/semaforo.service';

@Component({
  selector: 'app-alta-planes',
  templateUrl: './alta-planes.component.html',
  styleUrl: './alta-planes.component.css'
})
export class AltaPlanesComponent implements OnInit {

  public instituciones: Instituciones[] = [];
  public planeacion: Planificacion[] = [];
  public semaforo: Semaforos[] = []; //guarda las propiedades
  public newsemaforo: Semaforos[] = []; //guarda las propiedades
  public semaforoOriginal: Semaforos[] = []; //copia de los semáforos originales antes de cambios
  public responsables: Responsables[] = [];
  public diasLab = ['Lunes-Viernes', 'Lunes-Sabado', 'Lunes-Domingo',]
  private acceso = [];
  public mostabla: boolean = false; //Controlar visibilidad de la tabla


  public modal = false; //para la planeación
  public modal2 = false; //para edición
  public modal3 = false; //para el semáforo
  public idplan: number = 0; //id de planificacion

  public planeacin: any; //para edit

  //form select

  public diaslaborablesSelect: any = 'Lunes-Viernes'; // Valor por defecto

  public toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true
  });
  public isActiveSelect: any; //isActive por ser check
  public resSelect: any;

  public selecsemEdit = false;
  public borraoSem = false;
  public plansemEdit: any;
  public semaforoOriginalCount: number = 0; // Guardar cantidad original de semáforos

  //  para convertir Date a formato YYYY-MM-DD para inputs 
  formatDateForInput(date: Date | string): string {
    if (!date) return '';
    
    const dateObj = date instanceof Date ? date : new Date(date);
    
    if (isNaN(dateObj.getTime())) return ''; // Fecha inválida
    
    const year = dateObj.getFullYear();
    const month = String(dateObj.getMonth() + 1).padStart(2, '0');
    const day = String(dateObj.getDate()).padStart(2, '0');
    
    return `${year}-${month}-${day}`;
  }

  //verificar si una fecha es válida según días laborables
  isValidDate(dateString: string): boolean {
    if (!dateString) return true;
    
    const parts = dateString.split('-');
    const year = parseInt(parts[0]);
    const month = parseInt(parts[1]) - 1; 
    const day = parseInt(parts[2]);
    
    const date = new Date(year, month, day);
    const dayOfWeek = date.getDay(); // 0=Domingo, 1=Lunes, 2=Martes, ..., 6=Sábado
    
    // Lunes-Viernes: solo días 1, 2, 3, 4, 5 (excluir sábado=6 y domingo=0)
    if (this.diaslaborablesSelect === 'Lunes-Viernes' && (dayOfWeek === 0 || dayOfWeek === 6)) {
      return false;
    }
    // Lunes-Sábado: solo días 1, 2, 3, 4, 5, 6 (excluir solo domingo=0)
    else if (this.diaslaborablesSelect === 'Lunes-Sabado' && dayOfWeek === 0) {
      return false;
    }
    return true;
  }

  onDateChange(event: any, controlName: string, formGroup: FormGroup): void {
    const selectedDate = event.target.value;
    
    if (!this.isValidDate(selectedDate)) {
      // Si la fecha no es válida, limpiar el campo
      formGroup.get(controlName)?.setValue('');
      event.target.value = '';
      
      let message = '';
      if (this.diaslaborablesSelect === 'Lunes-Viernes') {
        message = 'Solo puedes seleccionar días de lunes a viernes.';
      } else if (this.diaslaborablesSelect === 'Lunes-Sabado') {
        message = 'Solo puedes seleccionar días de lunes a sábado.';
      } else {
        message = 'Solo puedes seleccionar días de lunes a domingo.';
      }
      
      if (message) {
        this.toast.fire({
          icon: 'warning',
          title: message
        });
      }
    }
  }

  onDateInput(event: any, controlName: string, formGroup: FormGroup): void {
    const inputValue = event.target.value;
    
    if (inputValue && !this.isValidDate(inputValue)) {
      // Resetear el valor inmediatamente
      setTimeout(() => {
        event.target.value = '';
        formGroup.get(controlName)?.setValue('');
        
        let message = '';
        if (this.diaslaborablesSelect === 'Lunes-Viernes') {
          message = 'Solo se permiten días de lunes a viernes';
        } else if (this.diaslaborablesSelect === 'Lunes-Sabado') {
          message = 'Solo se permiten días de lunes a sábado';
        } else {
          message = 'Fecha no válida según configuración';
        }
        
        if (message) {
          this.toast.fire({
            icon: 'warning',
            title: message,
            timer: 2000
          });
        }
      }, 50);
    }
  }

  /** Validaciones inputs */
  formNuevo = new FormGroup({
    'inputName': new FormControl('', [Validators.required]),
    'inputDays': new FormControl('', [Validators.required]),
    'inputFechaIni': new FormControl('', [Validators.required]),
    'inputFechaFin': new FormControl('', [Validators.required]),
    'inputIntstitucion': new FormControl('', [Validators.required]),
    'inputResponsble': new FormControl('', [Validators.required]),
    'inputNumColor': new FormControl('', [Validators.required]),
    'inputColor0': new FormControl('', [Validators.required]),
    'inputColor1': new FormControl('', [Validators.required]),
    'inputColor2': new FormControl('', [Validators.required]),
    'inputColor3': new FormControl('', [Validators.required]),
    'inputColor4': new FormControl('', [Validators.required]),
    'inputVal1Sem0': new FormControl({ value: 0, disabled: true }, [Validators.required]),
    'inputVal2Sem0': new FormControl('', [Validators.required]),
    'inputVal1Sem1': new FormControl({ value: '', disabled: true }, [Validators.required]),
    'inputVal2Sem1': new FormControl('', [Validators.required]),
    'inputVal1Sem2': new FormControl({ value: '', disabled: true }, [Validators.required]),
    'inputVal2Sem2': new FormControl('', [Validators.required]),
    'inputVal1Sem3': new FormControl({ value: '', disabled: true }, [Validators.required]),
    'inputVal2Sem3': new FormControl('', [Validators.required]),
    'inputVal1Sem4': new FormControl({ value: '', disabled: true }, [Validators.required]),
    'inputVal2Sem4': new FormControl(100, [Validators.required]),
  });

  formEdit = new FormGroup({
    'inputName': new FormControl('', [Validators.required]),
    'inputDays': new FormControl('', [Validators.required]),
    'inputFechaIni': new FormControl('', [Validators.required]),
    'inputFechaFin': new FormControl('', [Validators.required]),
    'inputIntstitucion': new FormControl('', [Validators.required]),
    'inputResponsble': new FormControl('', [Validators.required]),
  });

  formSemaforo = new FormGroup({
    'inputNumColor': new FormControl('', [Validators.required]),
    'inputColor0': new FormControl('', [Validators.required]),
    'inputColor1': new FormControl('', [Validators.required]),
    'inputColor2': new FormControl('', [Validators.required]),
    'inputColor3': new FormControl('', [Validators.required]),
    'inputColor4': new FormControl('', [Validators.required]),
    'inputVal1Sem0': new FormControl({ value: 0, disabled: true }, [Validators.required]),
    'inputVal2Sem0': new FormControl('', [Validators.required]),
    'inputVal1Sem1': new FormControl({ value: '', disabled: true }, [Validators.required]),
    'inputVal2Sem1': new FormControl('', [Validators.required]),
    'inputVal1Sem2': new FormControl({ value: '', disabled: true }, [Validators.required]),
    'inputVal2Sem2': new FormControl('', [Validators.required]),
    'inputVal1Sem3': new FormControl({ value: '', disabled: true }, [Validators.required]),
    'inputVal2Sem3': new FormControl('', [Validators.required]),
    'inputVal1Sem4': new FormControl({ value: '', disabled: true }, [Validators.required]),
    'inputVal2Sem4': new FormControl(100, [Validators.required]),
  });

  get fn() { return this.formNuevo.controls; }
  get fe() { return this.formEdit.controls; }
  get fc() { return this.formSemaforo.controls; }

  constructor(
    public dataService: DataService,
    public translate: TranslateService,
    private contenedorService: ContenedorService,
    private excelService: ExcelService,
    private router: Router,
    private cookies: CookieService,

    private planificacionService: PlanificacionService,
    private semaforoService:SemaforoService,
    private responsableService: ResponsableService,
  ) {
    this.initializeAccess();
  }

  private async initializeAccess() {
    try {
      const response = await firstValueFrom(this.contenedorService.getAccess(this.dataService.user));
      if (response && response.access.length !== 0) {
        this.acceso = [];
        for (const acces of response.access) {
          this.acceso.push('' + acces);
        }
      } else {
        this.acceso = ['no encontrado'];
      }
      await this.obtData();
    } catch (error) {
      this.acceso = ['no encontrado'];
      await this.obtData();
    }
  }

  ngOnInit(): void { }

  private ordenamientoPer(array: any) {
    array.sort(function (a: any, b: any) {
      if (Number(a.id) > Number(b.id)) {
        return 1;
      }
      if (Number(a.id) < Number(b.id)) {
        return -1;
      }
      // a must be equal to b
      return 0;
    });
    return array;
  }
  private ordenarSem(array: any) {
    array.sort(function (a: any, b: any) {
      if (a.valor_00 > b.valor_00) {
        return 1;
      }
      if (a.valor_00 < b.valor_00) {
        return -1;
      }
      // a must be equal to b
      return 0;
    });
    return array;
  }

  public async obtData() {
    try {
      const institutionsResponse = await firstValueFrom(this.planificacionService.getInstituciones());
      this.instituciones = [];
      for (const inst of institutionsResponse) {
        if (this.accesoPlan(inst.id)) {
          this.instituciones.push({
            nombre: inst.name,
            acronimo: inst.acronym,
            id: inst.id,
          });
        }
      }

      const planificationsResponse = await this.planificacionService.getPlanificacionesGQL();
      this.guardarPlan(planificationsResponse);
      this.planeacion = this.ordenamientoPer(this.planeacion);

      const responsablesResponse = await firstValueFrom(this.responsableService.getResponsable());
      this.responsables = [];
      for (const are of responsablesResponse) {
        for (const res of are.responsibles) {
          this.responsables.push({
            nombre: res.name,
            id: res.id,
            apellido_paterno: res.first_surname,
            apellido_materno: res.second_surname,
            institucionId: are.institution.id,
          });
        }
      }
      this.responsables = this.ordenamientoPer(this.responsables);
      this.mostabla = true; //Mostrar tabla cuando los datos están listos
    } catch (error) {
      messages.errorMessageGraph('Error al obtener los datos');
    }
  }

  private accesoPlan(id: any) {
    if (this.acceso[0] === 'all' || this.acceso.includes(id) || this.acceso[0] === 'no encontrado') {
      return true;
    }
    return false;
  }

  public guardarPlan(array: any) {
    var aux = [];
    for (const plan of array) {
      if (plan.institution !== null && this.accesoPlan(plan.institution.id)) {
        var aux2 = [];
        for (const sema of plan.signals) {
          aux2.push({
            id: sema.id,
            nombre: sema.name,
            valor_00: sema.value_00,
            valor_01: sema.value_01,
            color: sema.color[0],
            planningId: plan.id,
          });
        }
        aux2 = this.ordenarSem(aux2)
        aux.push({
          semaforos: aux2,
          id: plan.id,
          nombre: plan.name,
          fecha_inicio: moment(plan.initial_date).toDate(),
          fecha_fin: moment(plan.end_date).toDate(),
          institucionId: plan.institution.id,
          isActive: plan.isActive,
          business_days: plan.business_days,
          responsible: plan.responsible.id,
          enableMailReports: plan.enableMailReports,
        });
        
      }
    }
    this.planeacion = [];
    this.planeacion = aux;
  }

  public async alertas(aler: any, plan?: any) {
    if (aler === 'editar') {
      const result = await messages.confirmationSave(
        this.translate.instant('swal.confirmarGuardar'),
        this.translate.instant(''),
        this.translate
      );
      if (result) {
        await this.almacenarDatosEditados();
      }
    } else if (aler === 'guardar') {
      const result = await messages.confirmationSave(
        this.translate.instant('swal.confirmarInformacion'),
        this.translate.instant(''),
        this.translate
      );
      if (result) {
        await this.almacenarD();
      }
    } else if (aler === 'editSem') {
      const result = await messages.confirmationSave(
        this.translate.instant('swal.confirmarGuardar'),
        this.translate.instant(''),
        this.translate
      );
      if (result) {
        // Comparar si la cantidad de semáforos cambió
        const cantidadActual = this.newsemaforo.length;
        if (cantidadActual !== this.semaforoOriginalCount) {
          // La cantidad cambió: eliminar los antiguos y crear nuevos
          await this.almacenarDEditSemaforoNew();
        } else {
          // La cantidad NO cambió: solo actualizar valores
          await this.almacenarDEditSemaforo();
        }
      }
      this.modal3 = false;
    } else if (aler === 'eliminarPlan') {
      const result = await messages.confirmationSave(
        this.translate.instant('gestion.admin.altaPlanes.confirmarEliminarPlaneacion'),
        this.translate.instant(''),
        this.translate
      );
      if (result) {
        await this.Eliminar(plan);
      }
    }
  }

  private async getPlaneaciones(){
    const planificationsResponse = await this.planificacionService.getPlanificacionesGQL();
    this.guardarPlan(planificationsResponse);
    this.planeacion = this.ordenamientoPer(this.planeacion);
  }

  public async almacenarD() {
    try {
      //datos de la planificación
      var plan = new Planificacion();
      plan.id = this.planeacion.length + 1;
      plan.nombre = this.fn['inputName'].value;
      plan.business_days = this.fn['inputDays'].value;
      plan.fecha_inicio = moment(this.fn['inputFechaIni'].value).toDate();
      plan.fecha_fin = moment(this.fn['inputFechaFin'].value).toDate();
      if (this.isActiveSelect === true) {
        plan.isActive = true;
      } else if (this.isActiveSelect === undefined) {
        plan.isActive = false;
      }
      plan.institucionId = Number(this.fn['inputIntstitucion'].value); //instituto
      plan.responsible = Number(this.fn['inputResponsble'].value);

      await firstValueFrom(this.planificacionService.postPlan(plan));

      await this.getPlaneaciones();
      var idpla = this.planeacion[this.planeacion.length - 1].id;

      //aquí debe empezar lo de semáforos.
      for (var i = 0; i < this.newsemaforo.length; i++) {
        this.newsemaforo[i].valor_00 = Number(this.formNuevo.controls['inputVal1Sem' + i].value);
        if (i === this.newsemaforo.length - 1) {
          this.newsemaforo[i].valor_01 = Number(this.formNuevo.controls['inputVal2Sem4'].value);
        } else {
          this.newsemaforo[i].valor_01 = Number(this.formNuevo.controls['inputVal2Sem' + i].value);
        }
        this.newsemaforo[i].color = this.formNuevo.controls['inputColor' + i].value;
        this.newsemaforo[i].operador_00 = 'entre';
        this.newsemaforo[i].operador_01 = 'and';
        this.newsemaforo[i].nombre = 'Semaforo ' + (i + 1);
        this.newsemaforo[i].planningId = idpla;

        await firstValueFrom(this.semaforoService.postSemaforo(this.newsemaforo[i]));
      }
      this.getPlaneaciones();
      this.newsemaforo = [];
      this.cerrarForm();

      messages.succesMessageGraph(this.translate.instant('swal.infoGuardado'));
    } catch (err: any) {
      let er = obtenerError.errorObt(err['error'].message);
      messages.errorMessageGraph(err.message);
    }
  }

  public async almacenarDEditSemaforo() {
    try {
      // Usar los IDs originales de semaforoOriginal pero con los valores nuevos del formulario
      for (var i = 0; i < this.semaforoOriginal.length; i++) {
        this.semaforoOriginal[i].valor_00 = Number(this.formSemaforo.controls['inputVal1Sem' + i].value);
        if (i === this.semaforoOriginal.length - 1) {
          this.semaforoOriginal[i].valor_01 = Number(this.formSemaforo.controls['inputVal2Sem4'].value);
        } else {
          this.semaforoOriginal[i].valor_01 = Number(this.formSemaforo.controls['inputVal2Sem' + i].value);
        }
        this.semaforoOriginal[i].color = this.formSemaforo.controls['inputColor' + i].value;

        await firstValueFrom(this.semaforoService.patchSemaforo(this.semaforoOriginal[i]));
        this.getPlaneaciones();
      }

      messages.succesMessageGraph(this.translate.instant('swal.swalGuardo'));
      this.selecsemEdit = false;
      this.newsemaforo = [];
      this.semaforoOriginal = [];
      this.modal3 = false;
    } catch (err: any) {
      let er = obtenerError.errorObt(err['error'].message);
      Swal.fire({
        title: er,
        text: '',
        icon: 'error',
        showConfirmButton: false,
        timer: this.dataService.time,
      });
    }
  }

  public async almacenarDEditSemaforoNew() {
    try {
      // PASO 1: Eliminar semáforos originales de la BD
      for (const sem of this.semaforoOriginal) {
        try {
          await firstValueFrom(this.semaforoService.deleteSemaforo(sem));
        } catch (err: any) {
          // Ignorar el error de eliminación
        }
      }

      // PASO 2: Crear nuevos semáforos con los valores del formulario
      for (var i = 0; i < this.newsemaforo.length; i++) {
        this.newsemaforo[i].valor_00 = Number(this.formSemaforo.controls['inputVal1Sem' + i].value);
        if (i === this.newsemaforo.length - 1) {
          this.newsemaforo[i].valor_01 = Number(this.formSemaforo.controls['inputVal2Sem4'].value);
        } else {
          this.newsemaforo[i].valor_01 = Number(this.formSemaforo.controls['inputVal2Sem' + i].value);
        }
        this.newsemaforo[i].color = this.formSemaforo.controls['inputColor' + i].value; // string
        this.newsemaforo[i].operador_00 = 'entre';
        this.newsemaforo[i].operador_01 = 'and';
        this.newsemaforo[i].nombre = 'Semaforo ' + (i + 1);
        this.newsemaforo[i].planningId = this.plansemEdit; // Mantener como número

        await firstValueFrom(this.semaforoService.postSemaforo(this.newsemaforo[i]));
        this.getPlaneaciones();
      }

      messages.succesMessageGraph(this.translate.instant('swal.swalGuardo'));
      this.newsemaforo = [];
      this.semaforoOriginal = [];
      this.semaforoOriginalCount = 0;
      this.borraoSem = false;
      this.selecsemEdit = false;
      this.modal3 = false;
    } catch (err: any) {
      let er = obtenerError.errorObt(err['error'].message);
      messages.errorMessageGraph(err);
    }
  }

  public existe(idRes: any): boolean {
    if (this.fn["inputIntstitucion"].value === idRes || this.fe["inputIntstitucion"].value === idRes)
      return true;
    return false;
  }

  public elegirSem() {
    const numcolorSelect1 = document.getElementById('semaforos')['value']
    this.newsemaforo = [];
    switch (numcolorSelect1) {
      case 'tres':
        for (var i = 0; i < 3; i++)
          this.newsemaforo.push(new Semaforos());

        this.newsemaforo[0].valor_00 = 0;
        this.newsemaforo[this.newsemaforo.length - 1].valor_01 = 100;
        break;
      case 'cuatro':
        for (var i = 0; i < 4; i++)
          this.newsemaforo.push(new Semaforos());

        this.newsemaforo[0].valor_00 = 0;
        this.newsemaforo[this.newsemaforo.length - 1].valor_01 = 100;
        break;
      case 'cinco':
        for (var i = 0; i < 5; i++)
          this.newsemaforo.push(new Semaforos());

        this.newsemaforo[0].valor_00 = 0;
        this.newsemaforo[this.newsemaforo.length - 1].valor_01 = 100;
        break;
    }
  }

  public puede_guardar() {
    //datos de la planificación
    let nombre = this.fn['inputName'].value;
    let business_days = this.fn['inputDays'].value;
    let fecha_inicio = this.fn['inputFechaIni'].value;
    let fecha_fin = this.fn['inputFechaFin'].value;
    let institucion = this.fn['inputIntstitucion'].value;
    let responsable = this.fn['inputResponsble'].value;

    var semafor = false, sn = 0;
    for (var i = 0; i < this.newsemaforo.length; i++) {
      if (i === this.newsemaforo.length - 1) {
        if (this.fn['inputColor' + i].value === '') {
          sn++;
        }
      } else {
        if (this.fn['inputVal2Sem' + i].value === '' || this.fn['inputColor' + i].value === '') {
          sn++;
        }
      }
    }
    if (sn === 0 && this.fn['inputNumColor'].value !== '') {
      semafor = true;
    }

    if (nombre !== '' && business_days !== '' && fecha_inicio !== '' && fecha_fin !== '' && institucion !== '' && responsable !== '' && semafor) {
      return ''
    }
    return 'w3-disabled'
  }

  public puede_guardarEdit() {
    //datos de la planificación
    let nombre = this.fe['inputName'].value;
    let business_days = this.fe['inputDays'].value;
    let fecha_inicio = this.fe['inputFechaIni'].value;
    let fecha_fin = this.fe['inputFechaFin'].value;
    let institucion = this.fe['inputIntstitucion'].value;
    let responsable = this.fe['inputResponsble'].value;

    if (nombre !== '' && business_days !== '' && fecha_inicio !== '' && fecha_fin !== '' && institucion !== '' && responsable !== '') {
      return ''
    }
    return 'w3-disabled'
  }

  public puede_guardarEditSem() {
    var semafor = false, sn = 0;
    for (var i = 0; i < this.newsemaforo.length; i++) {
      if (i === this.newsemaforo.length - 1) {
        if (this.fc['inputColor' + i].value === '') {
          sn++;
        }
      } else {
        if (this.fc['inputVal2Sem' + i].value === '' || this.fc['inputColor' + i].value === '') {
          sn++;
        }
      }
    }
    if (sn === 0 && this.fc['inputNumColor'].value !== '') {
      semafor = true;
    }

    if (semafor) {
      return ''
    }
    return 'w3-disabled'
  }

  public async elegirSemEdit() {
    const numcolorSelect1 = document.getElementById('semaforosEdit')['value']
    
    // NO eliminar de la BD aquí, solo cambiar localmente
    this.newsemaforo = [];
    switch (numcolorSelect1) {
      case 'tres':
        for (var i = 0; i < 3; i++)
          this.newsemaforo.push(new Semaforos());

        this.newsemaforo[0].valor_00 = 0;
        this.newsemaforo[this.newsemaforo.length - 1].valor_01 = 100;
        break;
      case 'cuatro':
        for (var i = 0; i < 4; i++)
          this.newsemaforo.push(new Semaforos());

        this.newsemaforo[0].valor_00 = 0;
        this.newsemaforo[this.newsemaforo.length - 1].valor_01 = 100;
        break;
      case 'cinco':
        for (var i = 0; i < 5; i++)
          this.newsemaforo.push(new Semaforos());

        this.newsemaforo[0].valor_00 = 0;
        this.newsemaforo[this.newsemaforo.length - 1].valor_01 = 100;
        break;
    }
    for (const sem of this.newsemaforo) {
      sem.planningId = this.plansemEdit; // plansemEdit ya es el ID, no un objeto
    }
    this.borraoSem = true;
    this.selecsemEdit = false;
  }

  public async cambioEdit() {
    if (!this.selecsemEdit) {
      const result = await messages.confirmationSave(
        this.translate.instant('gestion.admin.altaPlanes.cambiarSemaforosBorrarInfo'),
        this.translate.instant(''),
        this.translate
      );
      if (result) {
        this.selecsemEdit = true;
      }
    }
    
  }

  public puedeSelec() {
    if (this.selecsemEdit) {
      return '';
    }
    return 'w3-disabled';
  }

  public haysem() {
    var semaforos = 0;
    for (const sem of this.semaforo) {
      if (sem.planningId === this.plansemEdit) {
        semaforos++;
      }
    }
    if (this.borraoSem) {
      return 'w3-disabled'
    }
    return '';
  }

  public setcolor(pos: any, color: any) {
    this.newsemaforo[pos].color = color;
  }

  public intNumero(introdujo: any) {
    if (this.modal3) {
      if (Number(this.formSemaforo.controls['inputVal2Sem' + introdujo].value) != 0) {
        this.formSemaforo.controls['inputVal1Sem' + (introdujo + 1)].setValue(Number(this.formSemaforo.controls['inputVal2Sem' + introdujo].value) + 0.1);
      } else {
        this.formSemaforo.controls['inputVal1Sem' + (introdujo + 1)].setValue("");
      }
    } else if (this.modal) {
      if (Number(this.formNuevo.controls['inputVal2Sem' + introdujo].value) != 0) {
        this.formNuevo.controls['inputVal1Sem' + (introdujo + 1)].setValue(Number(this.formNuevo.controls['inputVal2Sem' + introdujo].value) + 0.1);
      } else {
        this.formNuevo.controls['inputVal1Sem' + (introdujo + 1)].setValue("");
      }
    }

  }

  /* activación y desactivación notificación */
  public async activacionNotify(planeacion: any) {
    try {
      if (planeacion.enableMailReports === null) {
        planeacion.enableMailReports = true;
      } else {
        planeacion.enableMailReports = !planeacion.enableMailReports;
      }
      var text = planeacion.enableMailReports ? 
        this.translate.instant('gestion.admin.altaPlanes.notificacionesActivadas') : 
        this.translate.instant('gestion.admin.altaPlanes.notificacionesDesactivadas');

      await firstValueFrom(this.planificacionService.patchPlanNotificaciones(planeacion));
      this.getPlaneaciones();

      messages.succesMessageGraph(text);
    } catch (error: any) {
      messages.errorMessageGraph(error.message);
    }
  }

  public async activacionEdicion(planeacion: any) {
    try {
      planeacion.isActive = !planeacion.isActive;
      var text = planeacion.isActive ? 
        this.translate.instant('gestion.admin.altaPlanes.edicionTodosPeriodos') : 
        this.translate.instant('gestion.admin.altaPlanes.edicionRestringida');

      await firstValueFrom(this.planificacionService.patchPlanEdicion(planeacion));
      this.getPlaneaciones();

      messages.succesMessageGraph(text);
    } catch (error: any) {
      messages.errorMessageGraph(error.message);
    }
  }



  public async almacenarDatosEditados() {
    try {
      this.planeacin.nombre = this.fe['inputName'].value;
      this.planeacin.business_days = this.fe['inputDays'].value;
      this.planeacin.fecha_inicio = moment(this.fe['inputFechaIni'].value).toDate();
      this.planeacin.fecha_fin = moment(this.fe['inputFechaFin'].value).toDate();
      if (this.isActiveSelect) {
        this.planeacin.isActive = true;
      } else if (this.isActiveSelect === undefined || !this.isActiveSelect) {
        this.planeacin.isActive = false;
      }
      this.planeacin.institucionId = Number(this.fe['inputIntstitucion'].value); //instituto
      this.planeacin.responsible = this.fe['inputResponsble'].value;

      await firstValueFrom(this.planificacionService.patchPlan(this.planeacin));
      this.getPlaneaciones();

      messages.succesMessageGraph(this.translate.instant('swal.swalGuardo'));

      this.cerrarForm();
    } catch (err: any) {
      let er = obtenerError.errorObt(err['error'].message);
      messages.errorMessageGraph(er);
    }
  }

  public async Eliminar(idp: number) {
    try {
      await firstValueFrom(this.planificacionService.deletePlan(idp));
      this.getPlaneaciones();

      messages.succesMessageGraph(this.translate.instant('gestion.admin.altaPlanes.planeacionEliminada'));
    } catch (err: any) {
      let er = obtenerError.errorObt(err['error'].message);
      messages.errorMessageGraph(er);
    }
  }

  /*MODALES*/
  public abrirFormAgregar(plann: any) {
    this.modal = true;
  }

  public abrirFormEdit(plann: any) {
    this.modal2 = true;
    this.planeacin = plann;
    this.idplan = plann.id;
    this.diaslaborablesSelect = plann.business_days;
    this.resSelect = plann.responsible;

    switch (this.diaslaborablesSelect) {
      case 'Lunes-Viernes':
        // Filtro aplicado en el validador dateValidator
        break;
      case 'Lunes-Sabado':
        // Filtro aplicado en el validador dateValidator
        break;
      case 'Lunes-Domingo':
        // Filtro aplicado en el validador dateValidator
        break;
    }

    this.formEdit.controls['inputName'].setValue(this.planeacin.nombre);
    this.formEdit.controls['inputDays'].setValue(this.planeacin.business_days);
    this.formEdit.controls['inputFechaIni'].setValue(this.formatDateForInput(this.planeacin.fecha_inicio));
    this.formEdit.controls['inputFechaFin'].setValue(this.formatDateForInput(this.planeacin.fecha_fin));
    this.formEdit.controls['inputIntstitucion'].setValue(this.planeacin.institucionId);
    this.formEdit.controls['inputResponsble'].setValue(this.planeacin.responsible);

    if (this.planeacin.isActive) {
      this.isActiveSelect = true;
    } else {
      this.isActiveSelect = false;
    }
  }

  public abrirFormSem(plann: any) { //editar semáforo
    this.newsemaforo = [];
    this.semaforoOriginal = []; // Limpiar copia anterior
    this.plansemEdit = plann.id;
    for (const sem of plann.semaforos) {
      this.newsemaforo.push(sem);
      // Hacer copia profunda para preservar todas las propiedades incluyendo id
      this.semaforoOriginal.push(JSON.parse(JSON.stringify(sem)));
    }
    this.semaforoOriginalCount = this.newsemaforo.length; // Guardar cantidad original
    switch (this.newsemaforo.length) {
      case 3: this.formSemaforo.controls['inputNumColor'].setValue('tres'); break;
      case 4: this.formSemaforo.controls['inputNumColor'].setValue('cuatro'); break;
      case 5: this.formSemaforo.controls['inputNumColor'].setValue('cinco'); break;
    }
    for (var i = 0; i < this.newsemaforo.length; i++) {
      this.formSemaforo.controls['inputVal1Sem' + i].setValue(this.newsemaforo[i].valor_00);
      if (i === this.newsemaforo.length - 1) {
        this.formSemaforo.controls['inputVal2Sem4'].setValue(this.newsemaforo[i].valor_01);
      } else {
        this.formSemaforo.controls['inputVal2Sem' + i].setValue(this.newsemaforo[i].valor_01);
      }
      this.formSemaforo.controls['inputColor' + i].setValue(this.newsemaforo[i].color);
    }
    this.modal3 = true;
  }

  public cerrarForm() {
    this.modal3 = false;
    this.modal2 = false;
    this.modal = false;
    this.isActiveSelect = undefined;

    this.formNuevo.reset();
    this.formEdit.reset();

    this.newsemaforo = [];

    this.formNuevo.controls['inputVal1Sem0'].setValue(0);
    this.formNuevo.controls['inputVal2Sem4'].setValue(100);
  }

  public isActiveperspectivas(plann: any) {
    this.idplan = plann.id;
    let nombre = plann.nombre;
    this.modificarCookie(this.idplan, nombre);
    this.router.navigateByUrl(`/app/formulacion/perspectivas`);
  }
  public isActivefilosofia(plann: any) {
    this.idplan = plann.id;
    let nombre = plann.nombre;
    this.modificarCookie(this.idplan, nombre);
    this.router.navigateByUrl(`/app/formulacion/filosofiacorporativa`);
  }
  public isActiveMatrizfloa(plann: any) {
    this.idplan = plann.id;
    let nombre = plann.nombre;
    this.modificarCookie(this.idplan, nombre);
    this.router.navigateByUrl(`/app/formulacion/matriz-foda`);
  }
  public isActiveObjetivos(plann: any) {
    this.idplan = plann.id;
    let nombre = plann.nombre;
    this.modificarCookie(this.idplan, nombre);
    this.router.navigateByUrl(`/app/formulacion/objetivos`);
  }
  public isActiveIndicadores(plann: any) {
    this.idplan = plann.id;
    let nombre = plann.nombre;
    this.modificarCookie(this.idplan, nombre);
    this.router.navigateByUrl(`/app/formulacion/indicadores-metas`);
  }
  public isActiveAlineamiento(plann: any) {
    this.idplan = plann.id;
    let nombre = plann.nombre;
    this.modificarCookie(this.idplan, nombre);
    this.router.navigateByUrl(`/app/formulacion/alineamiento-estrategico`);
  }
  public isActiveProyectos(plann: any) {
    this.idplan = plann.id;
    let nombre = plann.nombre;
    this.modificarCookie(this.idplan, nombre);
    this.router.navigateByUrl(`/app/formulacion/proyectos-estrategicos`);
  }
  public isActiveCuadro(plann: any) {
    this.idplan = plann.id;
    let nombre = plann.nombre;
    this.modificarCookie(this.idplan, nombre);
    this.router.navigateByUrl(`/app/formulacion/cuadro-mando-integral`);
  }

  private async modificarCookie(idPlan: any, nombre: any) {
    this.cookies.delete('idInstitucion', '/');
    this.cookies.delete('idPlanFin', '/');
    this.cookies.set('idInstitucion', idPlan, { path: '/' });
    this.cookies.set('nombreInstitucion', nombre, { path: '/' });
  }

  //obtener nombres de instituciones
  public obtInst(inst: any) {
    for (const ins of this.instituciones) {
      if (Number(inst.institucionId) === Number(ins.id)) {
        return ins.nombre;
      }
    }
    return '';
  }
  public escribirres(resid: any) {
    for (const res of this.responsables) {
      if (res.id === resid) {
        return res.nombre + ' ' + res.apellido_paterno + ' ' + res.apellido_materno;
      }
    }
    return '';
  }
  public escribirmes(ele: any) {
    return moment(ele).format('DD/MM/YYYY');
  }

  public filtrodias(lab: any) {
    this.diaslaborablesSelect = lab;
  }

  public exportar_excel() {
    const title = this.translate.instant('gestion.admin.altaPlanes.tituloExcel');
    const header = [
      this.translate.instant('gestion.admin.altaPlanes.excelNombre'), 
      this.translate.instant('gestion.admin.altaPlanes.excelResponsable'), 
      this.translate.instant('gestion.admin.altaPlanes.excelFechaInicial'), 
      this.translate.instant('gestion.admin.altaPlanes.excelFechaFinal'), 
      this.translate.instant('gestion.admin.altaPlanes.excelInstitucion'), 
      this.translate.instant('gestion.admin.altaPlanes.excelActiva')
    ];
    let rows = [];
    let cols = [];
    for (var i = 0; i < this.planeacion.length; i++) {
      cols.push(this.planeacion[i].nombre);
      cols.push(this.escribirres(this.planeacion[i].responsible));
      cols.push(this.escribirmes(this.planeacion[i].fecha_inicio));
      cols.push(this.escribirmes(this.planeacion[i].fecha_fin));
      cols.push(this.obtInst(this.planeacion[i]));
      this.planeacion[i].isActive ? cols.push('✓') : cols.push('―');
      rows.push(cols);
      cols = [];
    }
    this.excelService.generateExcelPlanificaciones(title, header, rows, 'Alta_de_planes');
  }

  public clickFuera(event, modal) {
    if (event.target === document.getElementById(modal)) {
      document.getElementById(modal).classList.add('moveShake');
      setTimeout(() => {
        document.getElementById(modal).classList.remove('moveShake');
      }, 600);
    }
  }
}
